import { Typography } from "@mui/material";

export function WaitingForValidation() {
  return <Typography color="secondary">Waiting for validation...</Typography>;
}
